module.exports = __webpack_public_path__ + "static/media/ol-logo-heart--outline.091a259c.svg";